import { commonService } from '.';
import axios from "axios";
const APIURL = process.env.PUBLIC_URL + "/api";

const getByIdEa = (idEa) => {
    return commonService.getWithParam('EEPLanguage?idEa=' + idEa, null);
};

const insert = (body) => {
    return commonService.post('EEPLanguage', body);
};

const deleteEEPLanguage = (id, idEa) => {
    return commonService.deleteWithParam('EEPLanguage?id=' + id + '&idEa=' + idEa, null);
};

const updateByIdEa = async (body, idEa) => {
    const endpoint = 'EEPLanguage?idEa=' + idEa;
    const url = `${APIURL}/` + endpoint;
    return await axios.put(url, body);
};

export const eepLanguageService = {
    getByIdEa,
    insert,
    deleteEEPLanguage,
    updateByIdEa
};
